import React, { useState } from 'react';
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';

const btnSize = 56;
const closedWidth = btnSize;
const openWidth = 170;
const padding = 18;

const FloatingEnterButton: React.FC = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  return (
    <div
      style={{
        position: 'fixed',
        bottom: 40,
        right: 40, // 恢复原始位置
        zIndex: 1001,
        width: open ? openWidth : closedWidth,
        height: btnSize,
        boxShadow: '0 4px 12px rgba(24, 144, 255, .35)', // 恢复蓝色阴影
        background: '#1890ff', // 恢复蓝色背景
        borderRadius: btnSize / 2,
        transition: 'width 0.25s cubic-bezier(.08,.82,.17,1),box-shadow .25s',
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        overflow: 'hidden',
        padding: `0 ${padding}px`,
        opacity: 0.96,
      }}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
      title="进入首页"
    >
      <div
        style={{
          width: btnSize,
          height: btnSize,
          borderRadius: '50%',
          background: 'rgba(24,144,255,1)', // 恢复蓝色背景
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#fff',
          fontSize: 28,
          transition: 'background .2s',
        }}
      >
        {/* 恢复右侧箭头图标 */}
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#FFF" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M13 5L20 12L13 19"/>
          <line x1="4" y1="12" x2="20" y2="12"/>
        </svg>
      </div>
      {/* 展开后显示文字和按钮 */}
      <div
        style={{
          maxWidth: open ? 110 : 0,
          opacity: open ? 1 : 0,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          color: 'white',
          fontSize: 16,
          fontWeight: 500,
          marginLeft: 8,
          transition: 'all 0.25s cubic-bezier(.08,.82,.17,1)',
          pointerEvents: open ? 'auto' : 'none',
        }}
      >
        进入首页
      </div>
      <Button
        type="link"
        style={{
          position: 'absolute',
          left: 0,
          top: 0,
          width: '100%',
          height: '100%',
          opacity: 0,
          cursor: 'pointer',
          zIndex: 9,
        }}
        tabIndex={-1}
        onClick={() => navigate('/show/main')}
      />
    </div>
  );
};

export default FloatingEnterButton;

